commusoftCommon.service('setDataCollection', function() {
    this.setData = function setData(fullObject){
        this.setInstanceId = fullObject;
    }
    this.getData = function getData(){
        return this.setInstanceId;
    }
});